import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './Categories.css';

function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    fetch('/api/categories')
      .then(res => res.json())
      .then(data => {
        setCategories(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Erreur:', err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="loading">Chargement des categories...</div>;
  }

  return (
    <div className="categories-page">
      <Helmet>
        <title>Categories | Annuaire des Pros - E-Shop Pro Paris</title>
        <meta name="description" content="Decouvrez nos realisations par secteur : coiffure, restauration, sante, commerce. Sites web et applications sur mesure a Paris." />
        <link rel="canonical" href="https://annuaire.e-shop-pro.fr/categories" />
      </Helmet>
      
      {/* Hero */}
      <section className="categories-hero">
        <div className="container">
          <h1>Toutes nos Categories</h1>
          <p>Explorez les realisations par secteur d'activite</p>
        </div>
      </section>
      
      {/* Categories List */}
      <section className="categories-list">
        <div className="container">
          <div className="categories-grid">
            {categories.map(cat => (
              <Link to={`/categorie/${cat.slug}`} key={cat.id} className="category-card">
                <div className="category-image">
                  <span className="category-icon">{cat.icone}</span>
                </div>
                <div className="category-content">
                  <h2>{cat.nom}</h2>
                  <p>{cat.description}</p>
                  <div className="category-meta">
                    <span>Voir les professionnels</span>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Categories;
